import { useState } from "react";
import CustomTextField from "../../components/FormElements/CustomTextField";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import OutlinedButton from "../../components/FormElements/Buttons/OutlinedButton";
import ContainedButton from "../../components/FormElements/Buttons/ContainedButton";
import { useDispatch } from "react-redux";
import { setLoading, showToast } from "../../store/slices/common";
import AxiosInstance from "../../services/networkServices";

export default function AddWords({ openDialog, handleCloseDialog, fetchList }) {
  const dispatch = useDispatch();
  const [hashTags, setHashTags] = useState([]);
  const [currentVal, setCurrentVal] = useState("");
  const handleHashtagInputKeyDown = (e) => {
    if (e.key === "Enter") {
      const splittedArr = currentVal?.split(",");
      setHashTags([...hashTags, ...splittedArr]);
      setCurrentVal("");
    }
  };
  const handleSubmit = async () => {
    try {
      dispatch(setLoading(true));
      const payload = {
        words: hashTags,
      };
      const resp = await AxiosInstance.post("/rap/add-words", payload);
      dispatch(showToast({ color: "success", msg: resp.data?.message }));
      fetchList();
    } catch (err) {
      console.error(err?.message);
    } finally {
      dispatch(setLoading(false));
      setHashTags([]);
      setCurrentVal("");
      handleCloseDialog();
    }
  };

  const handleRemoveHashtag = (idx) => {
    const clonedArr = [...hashTags];
    clonedArr.splice(idx, 1);
    setHashTags(clonedArr);
  };

  return (
    <Dialog
      sx={{
        zIndex: 9,
        "& .MuiDialog-container .MuiPaper-elevation": {
          borderRadius: "8px",
          width: "420px",
        },
      }}
      open={openDialog}
      onClose={handleCloseDialog}
    >
      <Box sx={{ padding: "20px 16px 0" }}>
        <DialogTitle
          sx={{ padding: "0 0 15px", textAlign: "center", fontWeight: 700 }}
        >
          Add Words
        </DialogTitle>
      </Box>
      <DialogContent sx={{ padding: "10px 16px 0" }}>
        <Typography
          sx={{
            fontSize: "10px",
            color: "gray",
            mt: 0,
            mb: 2,
            fontWeight: 400,
          }}
        >
          {" "}
          Click enter/return to add words
        </Typography>
        <CustomTextField
          label="Enter Word"
          // variant="outlined"
          // fullWidth
          value={currentVal}
          onChange={(e) => setCurrentVal(e.target.value)}
          onKeyDown={handleHashtagInputKeyDown}
        />
        <Box mt={2}>
          {hashTags.map((hashtag, index) => (
            <Button
              key={hashtag}
              onClick={() => handleRemoveHashtag(index)}
              variant="outlined"
              size="small"
              sx={{
                marginRight: 1,
                marginBottom: 1,
                fontSize: "12px",
                borderRadius: "8px",
                borderColor: "#142C5C",
                color: "#142C5C",
                fontWeight: 600,
              }}
            >
              {hashtag}
              <IconButton size="small" edge="end">
                <Close sx={{ color: "#142C5C", fontSize: "15px" }} />
              </IconButton>
            </Button>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "0 16px 20px" }}>
        <OutlinedButton
          onClick={() => {
            handleCloseDialog();
            setHashTags([]);
            setCurrentVal("");
          }}
          btnName={"Cancel"}
        />
        <ContainedButton onClick={handleSubmit} btnName="Add" />
      </DialogActions>
    </Dialog>
  );
}
